import type { BranchKey } from '@festina-life/api'
import { useMemo } from 'react'

import { useAllConciseBranches } from '../../../uiModels/branches/useAllConciseBranches'
import { getChildHierarchy } from '../branchesTree/helpers'

export const useBranchChildren = (forBranch: BranchKey) => {
  const conciseBranches = useAllConciseBranches()
  const specificationsForServer = conciseBranches[forBranch.server]

  return useMemo(() => {
    const hierarchy: string[] = []

    getChildHierarchy({
      conciseBranches: specificationsForServer ?? [],
      hierarchy,
      forNode: forBranch.name,
    })

    return hierarchy
  }, [forBranch.name, specificationsForServer])
}
